import ErrorPage from '../../common/components/ErrorPage';
import GeneralContentPage from '../../generalContent/components/GeneralContentPage';
import React from 'react';
import TaskListPage from './TaskListPage';
import withTaskFlow from './WithTaskFlow';
import { AssessmentPage, ScoreEvaluationPage } from '../../assessment/components';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { Location } from 'history';
import { RoutePageProps, RouteParams, RouteWithSubRoutes } from '../../base/components/Routes';
import { withBasicDetails } from '../../base/components/WithBasicDetails';

const EndPage = React.lazy(() => import('./EndPage'));
const HurdleFailPage = React.lazy(() => import('./HurdleFailPage'));
const QuizFeedbackPage = React.lazy(() => import('../../candidateFeedback/components/quizFeedback/QuizFeedbackPage'));
const VideoTaskModalPage = React.lazy(() => import('../../videoTask/components/VideoTaskModalPage'));

const taskRoutes: RouteParams[] = [
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['GENCONTENT']}/:itemId`,
    exact: true,
    component: GeneralContentPage,
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPASSES']}/:itemId`,
    exact: true,
    component: AssessmentPage,
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPQUIZ']}/:itemId`,
    exact: true,
    component: AssessmentPage,
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPASSES']}/:itemId${routeMappings['ASSESSMENT_EVALUATION']}`,
    exact: true,
    component: ScoreEvaluationPage,
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPQUIZ']}/:itemId${routeMappings['QUIZ_FEEDBACK']}`,
    exact: true,
    component: QuizFeedbackPage,
  },
  {
    path: `${routeMappings['TASK']}/*`,
    exact: true,
    component: ErrorPage,
  },
];

const videoRoute: RouteParams = {
  path: `${routeMappings['TASK']}/:id${routeMappings['EXPVIDEOTASK']}/:itemId`,
  exact: true,
  component: VideoTaskModalPage,
};

const taskListRoutes: RouteParams[] = [
  {
    path: `${routeMappings['TASKLIST']}/:id`,
    exact: true,
    component: withBasicDetails(TaskListPage),
  },
  {
    path: routeMappings['TASKLIST_END'],
    exact: true,
    component: withBasicDetails(withTaskFlow(EndPage)),
  },
  {
    path: routeMappings['TASKLIST_HURDLE_FAIL'],
    exact: true,
    component: withBasicDetails(withTaskFlow(HurdleFailPage)),
  },
];

const TaskRoutes = (): JSX.Element => {
  const location = useLocation<{ background: Location }>();
  const backgroundComponent = location.state?.background;
  return (
    <>
      <Switch location={backgroundComponent || location}>
        {/**Defined for video task refresh */}
        <Route exact path={videoRoute.path}>
          <Redirect to={taskListRoutes[0].path} />
        </Route>

        {taskRoutes.map((route: RouteParams, i: number) => {
          route.component = withBasicDetails(withTaskFlow(route.component));
          return <RouteWithSubRoutes key={i} {...route} />;
        })}

        {/* Defined as background for video task */}
        <Route path={taskListRoutes[0].path}>
          <TaskListPage />
        </Route>
        <Route path={taskListRoutes[1].path}>
          <EndPage />
        </Route>
      </Switch>

      {/* Show the modal when a background page is set */}
      {backgroundComponent && (
        <Route path={videoRoute.path}>
          {(props: RoutePageProps): JSX.Element => {
            const VideoTaskComponent: (props: RoutePageProps) => JSX.Element = withBasicDetails(
              withTaskFlow(videoRoute.component),
            );
            return <VideoTaskComponent {...props} />;
          }}
        </Route>
      )}
    </>
  );
};

taskListRoutes.push({
  path: `${routeMappings['TASK']}/`,
  exact: false,
  strict: true,
  component: TaskRoutes,
});

export default taskListRoutes;
